export const DEFAULT_EXPIRATION_DAYS = 183;
export enum EditableFiles {
	Docm = 'docm',
	Docx = 'docx',
	Odt = 'odt',
	Xlsb = 'xlsb',
	Xlsm = 'xlsm',
	Xlsx = 'xlsx',
	Ods = 'ods',
	Pptx = 'pptx',
	Ppsx = 'ppsx',
	Odp = 'odp',
}

export enum ConditionalLinkOptionsModalContentType {
	None,
	EditLinkOptionBeforeFirstLinkCreation,
	EditExistingLinkOption,
	CreateTemporaryLink,
}

export enum ResourceTypeLiteral {
	File = 'file',
	Folder = 'folder',
	LegacyFolder = 'lfolder',
	LegacyFile = 'lfile',
	FileVersion = 'filever',
	LegacyFileVersion = 'lfilever',
	InformationRequest = 'inforeq',
	WatermarkedFileResourceType = 'watermarkedfile',
	WatermarkedFileVersionResourceType = 'watermarkedfilever',
}

export enum PermissionName {
	View = 'View only',
	Download = 'Download',
	Edit = 'Edit',
	Owner = 'Owner',
	Upload = 'Upload',
}

export const WatermarkConstants = {
	FileResourceType: 'file',
	FileVersionResourceType: 'filever',
	WatermarkedFileResourceType: 'watermarkedfile',
	WatermarkedFileVersionResourceType: 'watermarkedfilever',
};
